var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:({
    exclude: ['drawer'],
    handler: 'hide'
  }),expression:"{\n    exclude: ['drawer'],\n    handler: 'hide'\n  }"}],ref:"drawer",staticClass:"drawer"},[_c('div',{ref:"drawerBlackdrop",staticClass:"drawer-blackdrop",on:{"click":_vm.hide}}),_vm._t("drawer")],2)}
var staticRenderFns = []

export { render, staticRenderFns }